export class DayTracker {
  map = new Map();
  static getKey(date) {
    return date.toISOString().split("T")[0];
  }
  getDate(date) {
    return this.map.get(DayTracker.getKey(date)) || null;
  }
  setDate(date, button) {
    this.map.set(DayTracker.getKey(date), button);
  }
}
//# sourceMappingURL=DayTracker.js.map